import { TAO_KOE, EN_KO } from './../libs';

class DynamicVideo {
	constructor( videoEl ) {
		this.videoEl = videoEl;

		// Update src for the video sources.
		const mediaList = {};
		const sourceEls = videoEl.querySelectorAll( 'source' );
		sourceEls.forEach( ( sourceEl ) => {
			if ( sourceEl.media ) {
				mediaList[ sourceEl.media ] = [].concat( mediaList[ sourceEl.media ] ?? [], sourceEl.src );
			}
		} );

		for ( const [ media, matchedSources ] of Object.entries( mediaList ) ) {
			const mq = window.matchMedia( media );
			mq.addEventListener( 'change', ( ev ) => {
				const matches = ev.matches;
				const isCurrentSrc = matchedSources.includes( videoEl.currentSrc );
				if ( matches !== isCurrentSrc ) {
					this.reload();
				}
			} );
		}
	}

	// Timeout so multiple calls still only trigger one reload.
	reloadTimeout = null;

	reload() {
		// Debounced Reload.
		clearTimeout( this.reloadTimeout );
		this.reloadTimeout = setTimeout( () => {
			if ( 'load' in this.videoEl ) {
				this.videoEl.load();
			}
		}, 100 );
	}
}

const handleLazyLoad = function( videoEl ) {
	let triggerLoad = false;

	// Update src for the video sources.
	const sourceEls = videoEl.querySelectorAll( 'source' );
	sourceEls.forEach( ( sourceEl ) => {
		if ( sourceEl.dataset.src ) {
			sourceEl.src = sourceEl.dataset.src;
			sourceEl.removeAttribute( 'data-src' );

			// Trigger load for Video, if we changed something in the source.
			triggerLoad = true;
		}
	} );

	// Trigger load for Video, if we changed something in the source.
	if ( triggerLoad && ( 'load' in videoEl ) ) {
		videoEl.load();
	}

	// Dynamic shift of sources depending on Media Attributes.
	videoEl.KOE_DYNAMIC_VIDEO ??= new DynamicVideo( videoEl );
};

const initVideoLazyLoad = function() {
	// Initialise Lazyloading.
	EN_KO.functions.initSimpleLazyLoadOnScroll( 'video.en_mdl_teaser__video', 'en_mdl_teaser__video--in_view', ( videoEl ) => handleLazyLoad( videoEl ) );
	EN_KO.functions.initSimpleLazyLoadOnScroll( 'video.mdl_image__video', 'mdl_image__video--in_view', ( videoEl ) => handleLazyLoad( videoEl ) );

	// Handle Lazyloaded videos.
	document.addEventListener( 'lazyload.tao', ( evt ) => {
		const containerEl = evt.target;
		const videoEls = containerEl.querySelectorAll( 'video.en_mdl_teaser__video' );
		videoEls.forEach( ( lazyEl ) => {
			EN_KO.functions.initSimpleLazyLoadOnScroll( lazyEl, 'en_mdl_teaser__video--in_view', ( videoEl ) => handleLazyLoad( videoEl ) );
		} );

		const videoEls2 = containerEl.querySelectorAll( 'video.mdl_image__video' );
		videoEls2.forEach( ( lazyEl ) => {
			EN_KO.functions.initSimpleLazyLoadOnScroll( lazyEl, 'mdl_image__video--in_view', ( videoEl ) => handleLazyLoad( videoEl ) );
		} );
	} );
};

// Init.
TAO_KOE.ready( 'video-lazy.js', initVideoLazyLoad );

// Export.
export {
	DynamicVideo as default,
	handleLazyLoad,
	initVideoLazyLoad,
};
